<!-- Deprecated in favour of separate files for SMS and Whatsapp and also to implement new providers for each platform in the future-->
<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import { isPhoneE164OrEmpty } from 'shared/helpers/Validators';
import { parseAPIErrorResponse } from 'dashboard/store/utils/api';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      accountSID: '',
      apiKeySID: '',
      authToken: '',
      medium: this.type,
      channelName: '',
      messagingServiceSID: '',
      useMessagingService: false,
      useAPIKey: false,
      phoneNumber: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
    authTokeni18nKey() {
      return this.useAPIKey ? 'API_KEY_SECRET' : 'AUTH_TOKEN';
    },
  },
  validations() {
    let validations = {
      channelName: { required },

      authToken: { required },
      accountSID: { required },
      medium: { required },
    };
    if (this.phoneNumber) {
      validations = {
        ...validations,
        phoneNumber: { required, isPhoneE164OrEmpty },
        messagingServiceSID: {},
      };
    } else {
      validations = {
        ...validations,
        messagingServiceSID: { required },
        phoneNumber: {},
      };
    }

    if (this.useAPIKey) {
      validations = {
        ...validations,
        apiKeySID: { required },
      };
    }
    return validations;
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const twilioChannel = await this.$store.dispatch(
          'inboxes/createTwilioChannel',
          {
            twilio_channel: {
              name: this.channelName,
              medium: this.medium,
              account_sid: this.accountSID,
              api_key_sid: this.apiKeySID,
              auth_token: this.authToken,
              messaging_service_sid: this.messagingServiceSID,
              phone_number: this.messagingServiceSID
                ? null
                : `+${this.phoneNumber.replace(/\D/g, '')}`,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: twilioChannel.id,
          },
        });
      } catch (error) {
        const errorMessage =
          parseAPIErrorResponse(error) ||
          this.$t('INBOX_MGMT.ADD.TWILIO.API.ERROR_MESSAGE');
        useAlert(errorMessage, {type: 'error'});
      }
    },
  },
};
</script>

<template>
  <form class="flex w-full flex-col" @submit.prevent="createChannel()">
    <!-- Cột 1: Thông tin cơ bản -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <!-- Cột trái -->
      <div class="space-y-4">
        <!-- Channel Name -->
        <div>
          <label :class="{ error: v$.channelName.$error }">
            {{ $t('INBOX_MGMT.ADD.TWILIO.CHANNEL_NAME.LABEL') }}
            <input
              v-model="channelName"
              type="text"
              :placeholder="$t('INBOX_MGMT.ADD.TWILIO.CHANNEL_NAME.PLACEHOLDER')"
              @blur="v$.channelName.$touch"
            />
            <span v-if="v$.channelName.$error" class="message">{{
              $t('INBOX_MGMT.ADD.TWILIO.CHANNEL_NAME.ERROR')
            }}</span>
          </label>
        </div>

        <!-- Account SID -->
        <div>
          <label :class="{ error: v$.accountSID.$error }">
            {{ $t('INBOX_MGMT.ADD.TWILIO.ACCOUNT_SID.LABEL') }}
            <input
              v-model="accountSID"
              type="text"
              :placeholder="$t('INBOX_MGMT.ADD.TWILIO.ACCOUNT_SID.PLACEHOLDER')"
              @blur="v$.accountSID.$touch"
            />
            <span v-if="v$.accountSID.$error" class="message">{{
              $t('INBOX_MGMT.ADD.TWILIO.ACCOUNT_SID.ERROR')
            }}</span>
          </label>
        </div>

        <!-- Auth Token -->
        <div>
          <label :class="{ error: v$.authToken.$error }">
            {{ $t(`INBOX_MGMT.ADD.TWILIO.${authTokeni18nKey}.LABEL`) }}
            <input
              v-model="authToken"
              type="text"
              :placeholder="
                $t(`INBOX_MGMT.ADD.TWILIO.${authTokeni18nKey}.PLACEHOLDER`)
              "
              @blur="v$.authToken.$touch"
            />
            <span v-if="v$.authToken.$error" class="message">
              {{ $t(`INBOX_MGMT.ADD.TWILIO.${authTokeni18nKey}.ERROR`) }}
            </span>
          </label>
        </div>
      </div>

      <!-- Cột phải -->
      <div class="space-y-4">
        <!-- Phone Number / Messaging Service -->
        <div>
          <label
            v-if="useMessagingService"
            :class="{ error: v$.messagingServiceSID.$error }"
          >
            {{ $t('INBOX_MGMT.ADD.TWILIO.MESSAGING_SERVICE_SID.LABEL') }}
            <input
              v-model="messagingServiceSID"
              type="text"
              :placeholder="
                $t('INBOX_MGMT.ADD.TWILIO.MESSAGING_SERVICE_SID.PLACEHOLDER')
              "
              @blur="v$.messagingServiceSID.$touch"
            />
            <span v-if="v$.messagingServiceSID.$error" class="message">{{
              $t('INBOX_MGMT.ADD.TWILIO.MESSAGING_SERVICE_SID.ERROR')
            }}</span>
          </label>

          <label
            v-else
            :class="{ error: v$.phoneNumber.$error }"
          >
            {{ $t('INBOX_MGMT.ADD.TWILIO.PHONE_NUMBER.LABEL') }}
            <input
              v-model="phoneNumber"
              type="text"
              :placeholder="$t('INBOX_MGMT.ADD.TWILIO.PHONE_NUMBER.PLACEHOLDER')"
              @blur="v$.phoneNumber.$touch"
            />
            <span v-if="v$.phoneNumber.$error" class="message">{{
              $t('INBOX_MGMT.ADD.TWILIO.PHONE_NUMBER.ERROR')
            }}</span>
          </label>
        </div>

        <!-- API Key (nếu sử dụng) -->
        <div v-if="useAPIKey">
          <label :class="{ error: v$.apiKeySID.$error }">
            {{ $t('INBOX_MGMT.ADD.TWILIO.API_KEY.LABEL') }}
            <input
              v-model="apiKeySID"
              type="text"
              :placeholder="$t('INBOX_MGMT.ADD.TWILIO.API_KEY.PLACEHOLDER')"
              @blur="v$.apiKeySID.$touch"
            />
            <span v-if="v$.apiKeySID.$error" class="message">{{
              $t('INBOX_MGMT.ADD.TWILIO.API_KEY.ERROR')
            }}</span>
          </label>
        </div>
      </div>
    </div>

    <!-- Options - Full width -->
    <div class="mt-6 space-y-4">
      <!-- Messaging Service Option -->
      <div class="messagingServiceHelptext">
        <label for="useMessagingService">
          <input
            id="useMessagingService"
            v-model="useMessagingService"
            type="checkbox"
            class="checkbox"
          />
          {{
            $t(
              'INBOX_MGMT.ADD.TWILIO.MESSAGING_SERVICE_SID.USE_MESSAGING_SERVICE'
            )
          }}
        </label>
      </div>

      <!-- API Key Option -->
      <div class="messagingServiceHelptext">
        <label for="useAPIKey">
          <input
            id="useAPIKey"
            v-model="useAPIKey"
            type="checkbox"
            class="checkbox"
          />
          {{ $t('INBOX_MGMT.ADD.TWILIO.API_KEY.USE_API_KEY') }}
        </label>
      </div>
    </div>

    <!-- Submit Button -->
    <div class="w-full flex justify-center mt-6">
      <woot-submit-button
        class="!bg-n-bluegray-4 !text-white rounded-lg"
        :loading="uiFlags.isCreating"
        :button-text="$t('INBOX_MGMT.ADD.TWILIO.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>

<style lang="scss" scoped>
.messagingServiceHelptext {
  margin-top: -10px;
  margin-bottom: 15px;

  .checkbox {
    margin: 0px 4px;
  }
}

.space-y-4 > * + * {
  margin-top: 1rem;
}
</style>
